import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import VendorDiligencePageUI from "./VendorDiligencePageUI";
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils";

class VendorDiligencePageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      createMode: false,
      companyName: "",
      cin: "",             
      cinError: "",
      companyDetails: null,
      loadingCompanyDetails: false,
      vendorDiligenceList: [],
      loadingVendorDiligence: true
    };
  }

  componentDidMount() {
    this.onAuthenticate();
  }

  onAuthenticate = () => {  
    RestApiUtils.post(
      this.props.context,
      `/api/su/vendorDiligence/authenticate`,
      this.getCorpVedaAuthenticateCallback
    );
  };
  
  getCorpVedaAuthenticateCallback = (response) => {
    if (response && response.errorList && response.errorList.length) {
      this.setState({
        loadingVendorDiligence: false
      });
      console.error("Login failed:", response.errorList[0].message);
    } else if (response && response.success) {
      console.log("Login success response:", response);
      this.fetchVendorDiligenceList();
    }
  };
  
  fetchVendorDiligenceList = () => {
    RestApiUtils.get(
      this.props.context,
      `/api/su/vendorDiligence`,
      this.getVendorDiligenceCallback
    );
  };

  getVendorDiligenceCallback = (response) => {
    if (response && response.errorList && response.errorList.length) {
      console.error("Failed to fetch vendor diligence list:", response.errorList);
    } else {
      this.setState({ 
        vendorDiligenceList: response.vendorDiligenceList || [],
        loadingVendorDiligence: false
      });
      console.log("Vendor diligence list:", response.vendorDiligenceList);
    }
  };
  
  onCreateDiligenceClick = () => {
    this.setState({ createMode: true });
  };

  onCancelDiligenceCreate = () => {
    this.setState({ createMode: false });
  };
  
  onRefreshClick = () => {
    console.log("Refresh clicked");
    this.setState({
      loadingVendorDiligence: true
    }, () => {
      this.fetchVendorDiligenceList();
    });
  };
  
  formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = new Date(timestamp);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  render() {
    return (
      <VendorDiligencePageUI
        context={this.props.context}
        createMode={this.state.createMode}
        onCreateDiligenceClick={this.onCreateDiligenceClick}
        onCancelDiligenceCreate={this.onCancelDiligenceCreate}
        onRefreshClick={this.onRefreshClick}
        vendorDiligenceList={this.state.vendorDiligenceList}
        loadingVendorDiligence={this.state.loadingVendorDiligence}
        formatDate={this.formatDate}
      />
    );
  }
}

export default withRouter(VendorDiligencePageSF);